/** GridContainer registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseGridContainer } from './parser';
const gridContainerRegistration = {
    typeName: 'GridContainer',
    parser: parseGridContainer,
};
nodeRegistry.register(gridContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map